import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { api } from "../lib/api";
import { captureUtm } from "../lib/tracking";
import { getConsent } from "./CookieConsent";

/** Pixel Meta (Facebook / Instagram Ads). L'identifiant se règle dans l'admin
 *  (Talent → Pixel Facebook). Chargé seulement avec le consentement « publicité ». */
export default function MetaPixel() {
    const location = useLocation();
    const pixelId = useRef("");
    const loaded = useRef(false);

    const load = () => {
        if (loaded.current || !pixelId.current || !getConsent()?.advertising) return;
        loaded.current = true;
        /* eslint-disable */
        !function (f, b, e, v, n, t, s) {
            if (f.fbq) return; n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
            if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = "2.0"; n.queue = [];
            t = b.createElement(e); t.async = !0; t.src = v; s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
        }(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
        /* eslint-enable */
        window.fbq("init", pixelId.current);
        window.fbq("track", "PageView");
    };

    useEffect(() => {
        captureUtm();
        api.get("/public/tracking").then(({ data }) => { pixelId.current = data?.meta_pixel_id || ""; load(); }).catch(() => {});
        const onConsent = () => load();
        window.addEventListener("mboa-consent-change", onConsent);
        return () => window.removeEventListener("mboa-consent-change", onConsent);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const first = useRef(true);
    useEffect(() => {
        captureUtm();
        if (first.current) { first.current = false; return; }
        if (loaded.current && typeof window.fbq === "function") window.fbq("track", "PageView");
    }, [location.pathname]);

    return null;
}
